import { isFileUploadingAtom } from 'components/FileUploadToMediaStorage'
import { KeyboardEvent } from 'react'
import { useBus } from 'react-bus'

import { getStore } from '@/store'

import {
	isLoadingAtom,
	triggerNextStep,
} from '../GeneratorLayout/GeneratorFooter/NextButton'

export const useSubmitStepOnEnter = () => {
	const bus = useBus()

	const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key !== 'Enter' || event.nativeEvent.isComposing) return
		event.preventDefault()
		const store = getStore()
		if (
			event.repeat ||
			store.get(isLoadingAtom) ||
			store.get(isFileUploadingAtom)
		) {
			return
		}
		triggerNextStep(bus)
	}

	return { enterKeyHint: 'go', onKeyDown } as const
}
